import logo from './logo.svg';
import './App.css';
import Nav from './comp/header';
import Foot from './comp/footer';
function App() {
  return (
   <>

   <Nav></Nav>
    
      <main>
        <section className="hero">
          <div className="hero-text">
            <h2>
              Build modern web experiences <span>faster.</span>
            </h2>
            <p>
              A clean, responsive homepage built with React + normal CSS. Use it
              for your portfolio, product landing, or business site.
            </p>
            <div className="hero-buttons">
              <a href="#get-started" className="btn primary">
                Get started
              </a>
              <a href="#features" className="btn secondary">
                View features
              </a>
            </div>
          </div>

          <div className="hero-image">
            <img
              src="team.jpg"
              alt="Hero mockup"
            />
          </div>
        </section>

       
        <section id="features" className="features">
          <h3>Features</h3>
          <p>Everything you need to get started quickly and easily.</p>
          <div className="feature-grid">
            <FeatureCard title="Responsive" desc="Looks great on all devices." />
            <FeatureCard title="Accessible" desc="Clean semantic HTML & ARIA." />
            <FeatureCard title="Customizable" desc="Easily adaptable styles." />
            <FeatureCard title="Performance" desc="Lightweight and fast." />
            <FeatureCard title="Developer Friendly" desc="Clear, reusable code." />
            
          </div>
        </section>

       
        <section id="get-started" className="cta">
          <h4>Ready to start?</h4>
          <p>Sign up and launch your site in minutes.</p>
          <div className="cta-buttons">
            <a href="#" className="btn white">
              Create account
            </a>
            <a href="#" className="btn outline">
              Contact sales
            </a>
          </div>
        </section>
      </main>
<Foot></Foot>
   </>
  );
}

function FeatureCard({ title, desc }) {
  return (
    <div className="feature-card">
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  );
}


export default App;
